import { useEffect } from "react";

import {
  clearLoggerContext,
  ExtraContext,
  setLoggerContext,
  UserSession,
} from "@/config/logger.config";
import { isDev } from "@/helpers/environment/environment.helpers";
import { useAuthenticationState } from "../useAuthenticationState/useAuthenticationState";
import { useCurrentCompany } from "../useCurrentCompany/useCurrentCompany";
import { useCurrentUser } from "../useCurrentUser/useCurrentUser";

export function useInitLogger() {
  const {
    authState: { decodedToken },
  } = useAuthenticationState();
  const { data: currentUserData } = useCurrentUser();
  const { currentCompany } = useCurrentCompany();

  const adminImpersonator = decodedToken?.["custom:admin_sso_id"];

  useEffect(() => {
    if (isDev()) {
      return;
    }

    if (!currentUserData || !currentCompany) {
      return;
    }

    const { getAgentV2: currentUser } = currentUserData;
    let extraContext = {
      connect_as: {
        admin_sso_id: "",
        impersonated_user: "",
      },
    } satisfies ExtraContext | {};

    if (adminImpersonator) {
      extraContext = {
        connect_as: {
          admin_sso_id: adminImpersonator,
          impersonated_user: currentUser.ID,
        },
      };
    }

    const userContext: UserSession = {
      company_id: currentCompany.id,
      user_id: currentUser.ID,
      tier_level: currentCompany.tierLevel,
      provider: currentCompany.provider,
      is_trial: Boolean(currentCompany.trial),
    };

    setLoggerContext(userContext, extraContext);

    return () => {
      clearLoggerContext();
    };
  }, [adminImpersonator, currentCompany, currentUserData]);
}
